import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';

function PaymentStatus({ icon, title, body, buttonCaption, showInviteCodeReferralButton, toggleSpinner }) {
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName={icon}
                iconColor="primary"
                headerText={title}
                secondaryText={<DangerouslyHtml dangerouslyHtml={body} />}
                primaryButtonCaption={buttonCaption}
                primaryButtonType="link"
                primaryButtonOnClick={(e) => {
                    e?.preventDefault();
                    toggleSpinner(true);
                    window.location.href = showInviteCodeReferralButton ? AUTH_PROFILE_INVITE + '?showPromoSliders=true' : AUTH_SEND_MAIN_LINK;
                }}
                primaryButtonLink={showInviteCodeReferralButton ? AUTH_PROFILE_INVITE + '?showPromoSliders=true' : AUTH_SEND_MAIN_LINK}
            />
        </BaseLayout>
    );
}

export default connect(null, {
    toggleSpinner,
})(PaymentStatus);
